const getTld = (url) => {
  if (!url) return null;
  const { hostname } = new URL(url);
  return hostname.substring(hostname.lastIndexOf('.'));
}

//URL parameters:

export const URL_PARAM_TOKEN = "token";
export const URL_PARAM_CODE = "code";
export const URL_PARAM_POPUP = "popup";
export const URL_PARAM_IFRAME = "iframe";
export const URL_PARAM_ERROR = "error";
export const URL_PARAM_CHALLENGE = "challenge";
export const URL_PARAM_ACCESS_TOKEN = "access_token";
export const URL_SEARCH_PARAM_ACCESS_TOKEN = `#${URL_PARAM_ACCESS_TOKEN}`;
export const URL_PARAM_EXPIRES_IN = "expires_in";
export const ERROR_VALUE_UNAUTHORIZED_CLIENT = "unauthorized_client";

//General variables
export const REDIRECT_URI = process.env.REACT_APP_AUTH_REDIRECT_URI;
export const REDIRECT_URI_POPUP = `${REDIRECT_URI}?${URL_PARAM_POPUP}=true`
export const REDIRECT_URI_IFRAME = `${REDIRECT_URI}?${URL_PARAM_IFRAME}=true`

export const CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
export const LOGIN_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;

export const PKCE_CHALLENGE_MODE = "S256";

//Storage variables:
export const STORAGE_PKCE_VERIFIER = "pkce_verifier";
export const STORAGE_PKCE_CHALLENGE = "pkce_challenge";
export const STORAGE_PKCE_CODE_RESPONSE = "pkce_code_response";
export const STORAGE_REDIRECT_AFTER_LOGIN = "redirectToAfterLogin";
export const STORAGE_TOKEN_EXPIRES_AT = "token_expires_at";
export const STORAGE_TOKEN = "token";

//Implicit grant variables (deprecated)
export const LOGIN_URL = `${process.env.REACT_APP_AUTH_BASE_URL}/oauth/authorize?client_id=${process.env.REACT_APP_AUTH_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_AUTH_REDIRECT_URI}&response_type=token`;
export const LOGOUT_URL = `${process.env.REACT_APP_AUTH_BASE_URL}/logout`;
export const AUTH_ENVIRONMENT = getTld(LOGIN_URL);

//legacy
export const KEY_ACCESS_TOKEN = URL_PARAM_ACCESS_TOKEN;
export const KEY_ACCESS_TOKEN_PREFIXED = URL_SEARCH_PARAM_ACCESS_TOKEN;
export const KEY_EXPIRES_IN = URL_PARAM_EXPIRES_IN;
export const KEY_REDIRECT_TO_AFTER_LOGIN = STORAGE_REDIRECT_AFTER_LOGIN;
export const KEY_TOKEN_EXPIRES_AT = STORAGE_TOKEN_EXPIRES_AT;

//Method selection variables:
export const LOGIN_MEDIATOR_ENABLED = process.env.REACT_APP_AUTH_MEDIATOR_ENABLED === "true";
export const LOGIN_POPUP_ENABLED = process.env.REACT_APP_AUTH_POPUP_ENABLED === 'true';
export const LOGIN_GENESYS_SDK_ENABLED = process.env.REACT_APP_AUTH_GENESYS_SDK_ENABLED === 'true';
export const LOGIN_USE_AWS_LAMBDA_FOR_TOKEN_REQUEST_ENABLED = process.env.REACT_APP_AUTH_USE_AWS_LAMBDA_FOR_TOKEN_REQUEST_ENABLED === 'true';
export const LOGIN_ENABLE_GENESYS_DESKTOP_IFRAME = process.env.REACT_APP_AUTH_ENABLE_GENESYS_DESKTOP_IFRAME === 'true';

//mediator
export const LOGIN_MEDIATOR_INITIATE_URL = `${process.env.REACT_APP_AUTH_MEDIATOR_BASE_URL}/auth/start`;
export const LOGIN_MEDIATOR_TOKEN_URL = `${process.env.REACT_APP_AUTH_MEDIATOR_BASE_URL}/auth/status`;

//genesys desktop proxy url
export const LOGIN_TOKEN_GENESYS_DESKTOP_PROXY_URL = process.env.REACT_APP_AUTH_TOKEN_URL_GENESYS_DESKTOP;

//public popup proxy url
export const LOGIN_TOKEN_POPUP_PROXY_URL = process.env.REACT_APP_AUTH_TOKEN_URL;

//sdk
export const LOGIN_GENESYS_SDK_ENVIRONMENT = process.env.REACT_APP_AUTH_GENESYS_SDK_ENVIRONMENT